<template>
      <div id="intro">
            <section class="section intro-hero animate__animated animate__fadeIn">
                  <BackButton link="/" />
                  <div class="grid-container max">
                        <div class="intro-hero-grid">
                              <div class="intro-hero-left">
                                    <h1>Built for<br />what&rsquo;s ahead</h1>
                                    <p class="intro-hero-lead">Every year, you make choices that move you forward&mdash;a new goal, a new routine, a new way of showing up for the people who count on you.</p>
                              </div>
                              <div class="intro-hero-right">
                                    <p class="intro-hero-para">Your healthcare should move forward with you. At Anthem, we&rsquo;re built for what&rsquo;s ahead with a wide network of doctors within our Blue Cross Blue Shield family. Backed by over 85 years of experience, we know how to support your health for wherever you&rsquo;re headed. Choose the plan that keeps up.</p>
                                    <p class="intro-hero-thanks">Thank you for choosing Anthem.</p>
                              </div>
                        </div>
                        <div class="intro-hero-btn-wrap">
                              <router-link to="/name" class="intro-hero-btn"><span>Next</span></router-link>
                        </div>
                  </div>
            </section>
      </div>
</template>

<script>
import BackButton from "../components/BackButton"
export default {
      name: "SHBPIntro",
      data() {
            return {
            }
      },
      mounted() {
            window.scrollTo(0, 0)
      },
      components: {
            BackButton
      }
}
</script>

<style lang="scss">
#intro {
      .intro-hero {
            background-color: #ffffff;
            margin-top: 68px;
            padding: 120px 0 100px 0;
            position: relative;
            min-height: calc(100vh - 68px);
            display: flex;
            flex-direction: column;
            justify-content: center;

            .back-btn {
                  left: 86px;
                  border-color: #1254E8;

                  &::before {
                        background-image: none;
                        background-color: #1254E8;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .intro-hero-grid {
                  display: flex;
                  flex-wrap: wrap;
                  align-items: center;
                  justify-content: space-between;
                  gap: 40px;
            }

            .intro-hero-left {
                  flex: 1 1 480px;
                  max-width: 600px;

                  h1 {
                        color: #1355E9;
                        font-size: clamp(4.25rem, 6.5vw, 5.25rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 24px;
                  }

                  .intro-hero-lead {
                        color: #012E58;
                        font-size: 1.75rem;
                        font-weight: 500;
                        line-height: 1.2;
                        margin-bottom: 0;
                  }
            }

            .intro-hero-right {
                  flex: 1 1 360px;
                  max-width: 500px;

                  .intro-hero-para {
                        color: #5a5665;
                        font-size: 1rem;
                        line-height: 1.6;
                        margin-bottom: 20px;
                  }

                  .intro-hero-thanks {
                        color: #1355E9;
                        font-size: 1rem;
                        font-weight: 600;
                        margin-bottom: 0;
                  }
            }

            .intro-hero-btn-wrap {
                  position: fixed;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  z-index: 3;
                  background-color: #ffffff;
                  box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.10);
                  padding: 20px 0;
                  text-align: center;
            }

            .intro-hero-btn {
                  display: block;
                  background-color: #1355E9;
                  color: #ffffff !important;
                  font-weight: 700;
                  text-transform: uppercase;
                  font-size: 1rem;
                  padding: 18px 0;
                  width: 100%;
                  max-width: 330px;
                  text-align: center;
                  border-radius: 30px;
                  margin: 0 auto;

                  &:hover {
                        background-color: #44B8F3;
                  }
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 100px 24px;

                  .back-btn {
                        left: 2rem;
                  }

                  .intro-hero-grid {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 0;
                  }

                  .intro-hero-left {
                        flex: 0 0 auto;
                        max-width: 100%;

                        h1 {
                              font-size: clamp(2rem, 11vw, 5.25rem) !important;
                        }

                        .intro-hero-lead {
                              font-size: 1.25rem;
                        }
                  }

                  .intro-hero-right {
                        flex: 0 0 auto;
                        max-width: 100%;
                  }
            }
      }
}
</style>
